<ng-container *transloco="let t; read: 'time-entries'">
  <p class="mbm">{{ t('workTimeViolations.description') }}</p>

  <form
    [formGroup]="filterForm"
    (ngSubmit)="onSubmitFilter()"
    class="grid col2 mbm"
  >
    <div class="span3 flex flexDirRow alignCenter gaps flexWrap">
      <div class="flexItem">
        <label for="violationEmployee">{{ t('employee') }}</label>
        <kendo-dropdownlist
          formControlName="employee"
          id="violationEmployee"
          [data]="employees$ | async"
          textField="lastName"
          valueField="id"
          [valuePrimitive]="false"
          [defaultItem]="employeeDefaultItem"
        >
          <ng-template kendoDropDownListItemTemplate let-dataItem>
            {{ dataItem?.id ? dataItem.firstName + ' ' + dataItem.lastName : t('all') }}
          </ng-template>
          <ng-template kendoDropDownListValueTemplate let-dataItem>
            {{ dataItem?.id ? dataItem.firstName + ' ' + dataItem.lastName : t('all') }}
          </ng-template>
        </kendo-dropdownlist>
      </div>

      <kendo-daterange>
        <kendo-floatinglabel text="Start" class="mrs">
          <kendo-dateinput
            formControlName="dateRangeStart"
            kendoDateRangeStartInput
          ></kendo-dateinput>
        </kendo-floatinglabel>
        <kendo-floatinglabel text="End">
          <kendo-dateinput
            formControlName="dateRangeEnd"
            kendoDateRangeEndInput
          ></kendo-dateinput>
        </kendo-floatinglabel>
        <kendo-daterange-popup [animate]="false"></kendo-daterange-popup>
      </kendo-daterange>

      <div class="flexItem">
        <label for="violationType">{{ t('workTimeViolations.type') }}</label>
        <kendo-dropdownlist
          formControlName="type"
          id="violationType"
          [data]="typeOptions"
          textField="value"
          valueField="value"
          [valuePrimitive]="true"
          [defaultItem]="typeDefaultItem"
        >
          <ng-template kendoDropDownListItemTemplate let-dataItem>
            {{ dataItem?.value !== null ? t('workTimeViolations.typeValues.' + typeName(dataItem.value)) : t('all') }}
          </ng-template>
          <ng-template kendoDropDownListValueTemplate let-dataItem>
            {{ dataItem?.value !== null ? t('workTimeViolations.typeValues.' + typeName(dataItem.value)) : t('all') }}
          </ng-template>
        </kendo-dropdownlist>
      </div>

      <div class="flexItem">
        <label for="violationStatus">{{ t('workTimeViolations.status') }}</label>
        <kendo-dropdownlist
          formControlName="status"
          id="violationStatus"
          [data]="statusOptions"
          textField="value"
          valueField="value"
          [valuePrimitive]="true"
          [defaultItem]="statusDefaultItem"
        >
          <ng-template kendoDropDownListItemTemplate let-dataItem>
            {{ dataItem?.value !== null ? t('workTimeViolations.statusValues.' + statusName(dataItem.value)) : t('all') }}
          </ng-template>
          <ng-template kendoDropDownListValueTemplate let-dataItem>
            {{ dataItem?.value !== null ? t('workTimeViolations.statusValues.' + statusName(dataItem.value)) : t('all') }}
          </ng-template>
        </kendo-dropdownlist>
      </div>

      <div class="flexItem">
        <button
          kendoButton
          themeColor="primary"
          type="submit"
          class="mrs"
          loadingIndication="/WorkTimeViolation/searchWorkTimeViolations"
        >
          {{ t('search') }}
        </button>
        <button kendoButton type="button" (click)="onResetFilter()">
          {{ t('reset') }}
        </button>
      </div>
    </div>
  </form>

  <kendo-grid
    [data]="gridData"
    [pageable]="true"
    [skip]="gridState.skip"
    [pageSize]="gridState.pageSize"
    (pageChange)="onPageChange($event)"
    scrollable="none"
  >
    <kendo-grid-column [title]="t('date')" field="date">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.date | date: "EE dd.MM.yyyy" }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [title]="t('employee')">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.employee?.firstName }} {{ dataItem.employee?.lastName }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [title]="t('workTimeViolations.type')" field="type">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ t('workTimeViolations.typeValues.' + typeName(dataItem.type)) }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [title]="t('workTimeViolations.details')" media="(min-width: 900px)">
      <ng-template kendoGridCellTemplate let-dataItem>
        <ng-container [ngSwitch]="dataItem.type">
          <ng-container *ngSwitchCase="WorkTimeViolationType.LunchBreak">
            {{ t('workTimeViolations.lunchBreakDetails', {
              window: dataItem.windowShort,
              workTime: dataItem.workTimeInWindowShort,
              effectiveBreak: dataItem.effectiveBreakShort,
              missingBreak: dataItem.missingBreakShort
            }) }}
          </ng-container>
          <ng-container *ngSwitchCase="WorkTimeViolationType.UnstoppedTimeEntry">
            {{ t('workTimeViolations.unstoppedDetails', { start: dataItem.entryStartShort }) }}
          </ng-container>
        </ng-container>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [title]="t('workTimeViolations.suggestion')" media="(min-width: 1200px)">
      <ng-template kendoGridCellTemplate let-dataItem>
        <ng-container *ngIf="dataItem.status === WorkTimeViolationStatus.Open" [ngSwitch]="dataItem.type">
          <ng-container *ngSwitchCase="WorkTimeViolationType.LunchBreak">
            <ng-container *ngIf="dataItem.suggestedStart">
              {{ t('workTimeViolations.suggestionText', {
                start: (dataItem.suggestedStart | date: 'HH:mm'),
                stop: (dataItem.suggestedStop | date: 'HH:mm')
              }) }}
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="WorkTimeViolationType.UnstoppedTimeEntry">
            {{ t('workTimeViolations.unstoppedSuggestion') }}
          </ng-container>
        </ng-container>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [title]="t('workTimeViolations.status')" field="status">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="status-badge" [ngClass]="statusClass(dataItem.status)">
          {{ t('workTimeViolations.statusValues.' + statusName(dataItem.status)) }}
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [title]="t('workTimeViolations.decision')" media="(min-width: 1200px)">
      <ng-template kendoGridCellTemplate let-dataItem>
        <ng-container *ngIf="dataItem.decisionDate">
          {{ dataItem.decisionDate | date: 'dd.MM.yyyy HH:mm' }}
          <ng-container *ngIf="dataItem.decisionMakerId">
            · {{ dataItem.decisionMakerId | employee | async }}
          </ng-container>
          <div *ngIf="dataItem.remark" class="k-text-muted">{{ dataItem.remark }}</div>
        </ng-container>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [title]="t('action')" *ngIf="hasActions" [width]="240">
      <ng-template kendoGridCellTemplate let-dataItem>
        <button
          kendoButton
          themeColor="primary"
          class="mrs"
          *ngIf="canCorrect(dataItem)"
          (click)="onCorrect(dataItem)"
          loadingIndication="/TimeEntry/getTimeEntry"
        >
          {{ t('workTimeViolations.correct') }}
        </button>
        <button
          kendoButton
          *ngIf="canIgnore && dataItem.status === WorkTimeViolationStatus.Open"
          (click)="onIgnore(dataItem)"
        >
          {{ t('workTimeViolations.ignore') }}
        </button>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoGridNoRecordsTemplate>{{ t('noResults') }}</ng-template>
  </kendo-grid>

  <!-- Ignore: a supervisor leaves the violation as it is; the remark is optional. -->
  <kendo-dialog
    *ngIf="violationToIgnore"
    [title]="t('workTimeViolations.ignoreTitle')"
    (close)="onCancelIgnore()"
    [width]="450"
    [maxWidth]="'95vw'"
  >
    <p class="mbs">
      {{ violationToIgnore.employee?.firstName }} {{ violationToIgnore.employee?.lastName }},
      {{ violationToIgnore.date | date: 'dd.MM.yyyy' }}
      · {{ t('workTimeViolations.typeValues.' + typeName(violationToIgnore.type)) }}
    </p>
    <p class="mbm">{{ t('workTimeViolations.ignoreDescription') }}</p>
    <form [formGroup]="ignoreForm" class="flex-col">
      <kendo-formfield>
        <kendo-label [text]="t('workTimeViolations.remark')"></kendo-label>
        <kendo-textarea formControlName="remark" [rows]="4" resizable="vertical"></kendo-textarea>
      </kendo-formfield>
    </form>

    <kendo-dialog-actions>
      <button kendoButton type="button" (click)="onCancelIgnore()">{{ t('cancel') }}</button>
      <button
        kendoButton
        type="button"
        themeColor="primary"
        (click)="onConfirmIgnore()"
        loadingIndication="/WorkTimeViolation/ignoreWorkTimeViolation"
      >
        {{ t('workTimeViolations.ignore') }}
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <!-- Correct: edits start/stop of the affected time entry, then re-evaluates the day at once. -->
  <kendo-dialog
    *ngIf="violationToCorrect && correctForm"
    [title]="t('workTimeViolations.correctTitle')"
    (close)="onCancelCorrect()"
    [width]="450"
    [maxWidth]="'95vw'"
  >
    <p class="mbs">
      {{ violationToCorrect.employee?.firstName }} {{ violationToCorrect.employee?.lastName }},
      {{ violationToCorrect.date | date: 'dd.MM.yyyy' }}
      · {{ t('workTimeViolations.typeValues.' + typeName(violationToCorrect.type)) }}
    </p>
    <p class="mbs k-text-muted" [ngSwitch]="violationToCorrect.type">
      <ng-container *ngSwitchCase="WorkTimeViolationType.LunchBreak">
        {{ t('workTimeViolations.lunchBreakDetails', {
          window: violationToCorrect.windowShort,
          workTime: violationToCorrect.workTimeInWindowShort,
          effectiveBreak: violationToCorrect.effectiveBreakShort,
          missingBreak: violationToCorrect.missingBreakShort
        }) }}
      </ng-container>
      <ng-container *ngSwitchCase="WorkTimeViolationType.UnstoppedTimeEntry">
        {{ t('workTimeViolations.unstoppedDetails', { start: violationToCorrect.entryStartShort }) }}
      </ng-container>
    </p>

    <!-- The entry being edited, for orientation; only start and stop are changed here. -->
    <p class="mbm">
      <strong>{{ t('workTimeViolations.correctEntry') }}:</strong>
      {{ entryToCorrect?.timeEntryCategory?.name }}
      <ng-container *ngIf="entryToCorrect?.assignment?.title"> · {{ entryToCorrect.assignment.title }}</ng-container>
      <ng-container *ngIf="entryToCorrect?.remarks"> · {{ entryToCorrect.remarks }}</ng-container>
    </p>

    <p class="mbm">
      {{ t(violationToCorrect.type === WorkTimeViolationType.LunchBreak
        ? 'workTimeViolations.correctHintLunch'
        : 'workTimeViolations.correctHintUnstopped') }}
    </p>

    <form [formGroup]="correctForm" class="flex flexDirRow gaps">
      <kendo-formfield>
        <kendo-label [text]="t('start')"></kendo-label>
        <kendo-maskedtextbox
          formControlName="start"
          [mask]="editMask"
          [includeLiterals]="true"
          [rules]="maskRules"
        ></kendo-maskedtextbox>
        <kendo-formerror>{{ t('isRequiredField') }}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]="t('stop')"></kendo-label>
        <kendo-maskedtextbox
          formControlName="stop"
          [mask]="editMask"
          [includeLiterals]="true"
          [rules]="maskRules"
        ></kendo-maskedtextbox>
        <kendo-formerror
          *ngIf="correctForm.get('stop').hasError('required') || correctForm.get('stop').hasError('isEmpty')"
        >{{ t('isRequiredField') }}</kendo-formerror>
      </kendo-formfield>
    </form>
    <kendo-formerror *ngIf="startIsLargerThanStop">{{ t('startIsLargerThanStop') }}</kendo-formerror>

    <kendo-dialog-actions>
      <button kendoButton type="button" (click)="onCancelCorrect()">{{ t('cancel') }}</button>
      <button
        kendoButton
        type="button"
        themeColor="primary"
        [disabled]="correctForm.invalid"
        (click)="onConfirmCorrect()"
        loadingIndication="/TimeEntry/updateTimeEntry"
      >
        {{ t('save') }}
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
</ng-container>
